import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'latest-post-item-placeholder',
  templateUrl: './latest-post-item-placeholder.component.html',
  styleUrls: ['./latest-post-item-placeholder.component.scss']
})
export class LatestPostItemPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/latest-posts-placeholder/latest-post-item-placeholder/latest-post-item-placeholder.component.ts